import React from 'react';
import PropTypes from 'prop-types';
import isNaN from 'lodash/isNaN';
import GoToPage from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogFooter/GoToPage';

import { Paginator } from '@els/els-react--paginator';

function Pagination({ totalPages, currentPage, onSelect, totalItems, shouldDisplayGoToPage, resultsPerPage }) {
  const selectPage = (value) => {
    const page = parseInt(value, 10);

    if (!isNaN(page) && page <= totalPages && page > 0 && page !== currentPage) {
      onSelect(page);
    }
  };

  return (
    <div className="o-els-flex-layout" style={{ alignItems: 'center' }}>
      {totalItems && (
        <Paginator
          onPageChange={(s) => {
            selectPage(s);
          }}
          resultsPerPage={resultsPerPage}
          totalResults={parseInt(totalItems, 10)}
          currentPage={currentPage}
          a11y={{ name: 'Results page pagination' }}
        />
      )}
      {shouldDisplayGoToPage && (
        <GoToPage
          chunksCount={totalItems}
          onClick={(page) => {
            onSelect(page);
          }}
        />
      )}
    </div>
  );
}

Pagination.propTypes = {
  resultsPerPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  totalItems: PropTypes.number.isRequired,
  shouldDisplayGoToPage: PropTypes.bool,
};

export default Pagination;
